<template>
    <ui-RichMenu v-bind="$attrs" :id="`componet_${_uid}`">
        <template v-slot:config>
            <slot name="config"></slot>
        </template>
        <template v-slot:options>
            <ui-RichMenuOption
                v-for="space in spaces"
                :key="space.id"
                :name="getName(space)"
                :icono="getType(space)"
                :edition="isEdit(space)"
                :acceptText="$dicc.accept"
                :deleteText="$dicc.delete"
                :cancelText="$dicc.cancel"
                :active="space.id == active"
                @acceptClick="updateSpace(space)"
                @deleteClick="deleteSpace(space)"
                @cancelClick="cancelEdit()"
                @click="$attrs.select ? $emit('optionsClick', space) : openEdit(space)"
                @clickAction="openEdit(space)"
            >
                <template v-slot:inputs>
                    <FormMixinInput
                        :label="$dicc.spaces.name"
                        property="name"
                        type="text"
                        :placeholder="$dicc.spaces.default"
                    ></FormMixinInput>
                    <FormMixinInput
                        :label="$dicc.spaces.type"
                        property="type"
                        type="select"
                        :options="getTypes()"
                    ></FormMixinInput>
                </template>
            </ui-RichMenuOption>
            <ui-RichMenuOption
                :name="$dicc.spaces.add"
                :add="true"
                :edition="isCreation()"
                :acceptText="$dicc.accept"
                :cancelText="$dicc.cancel"
                :showDelete="false"
                @acceptClick="addSpace"
                @cancelClick="cancelEdit()"
                @click="openCreation()"
            >
                <template v-slot:inputs>
                    <FormMixinInput
                        :label="$dicc.spaces.name"
                        property="name"
                        type="text"
                        :placeholder="$dicc.spaces.default"
                    ></FormMixinInput>
                    <FormMixinInput
                        :label="$dicc.spaces.type"
                        property="type"
                        type="select"
                        :options="getTypes()"
                    ></FormMixinInput>
                </template>
            </ui-RichMenuOption>
        </template>
    </ui-RichMenu>
</template>

<script>
    import { FormMixin } from '../mixins/FormMixin';

    export default {
        name: 'SpacenMenu',
        mixins: [FormMixin],
        props: {
            active: Number,
            loading: Number,
            location: Object,
        },
        data() {
            return {
                spaces: [],
            };
        },
        methods: {
            init() {
                this.$set(this, 'model', {});

                if (this.location) this.getSpaces();
            },

            getSpaces() {
                this.$emit('update:loading', this.loading + 1);

                this.$api.getSpaces(
                    this.location.id,
                    null,
                    (data) => (this.spaces = data.entity),
                    null,
                    () => this.$emit('update:loading', this.loading - 1)
                );
            },

            getTypes() {
                let typesWitoutOther = this.$fns.orderObjectByValue(this.$dicc.spaces.types);
                delete typesWitoutOther.OTHER;
                return { ...typesWitoutOther, OTHER: this.$dicc.spaces.types.OTHER };
            },

            getName(space) {
                return (this.isEdit(space) ? this.model.name : space.name) || this.$dicc.spaces.default;
            },

            getType(space) {
                return this.$class.space[this.isEdit(space) ? this.model.type : space.type];
            },

            isCreation() {
                return 0 == this.model.id;
            },

            isEdit(space) {
                return space.id == this.model.id;
            },

            openCreation() {
                this.openEdit({
                    id: 0,
                    name: '',
                    type: 'OTHER',
                    location_id: this.location ? this.location.id : 0,
                });
            },

            openEdit(space) {
                this.resetErrors();
                this.$set(this, 'model', { ...space });
            },

            cancelEdit() {
                this.resetErrors();
                this.$set(this, 'model', {});
            },

            addSpace() {
                this.$emit('update:loading', this.loading + 1);
                this.resetErrors();

                this.$api.createSpace(
                    this.model,
                    () => {
                        this.init();
                        this.$emit('updateSpace');
                        this.$toast({
                            message: this.$dicc.spacePanel.created,
                            container: `#componet_${this._uid}`,
                            type: 'is-success',
                        });
                    },
                    (error) => this.showError(error, `#componet_${this._uid}`),
                    () => this.$emit('update:loading', this.loading - 1)
                );
            },

            updateSpace(space) {
                this.$emit('update:loading', this.loading + 1);
                this.resetErrors();

                this.$api.updateSpace(
                    this.model,
                    () => {
                        this.init();
                        this.$emit('updateSpace');
                        this.$toast({
                            message: this.$dicc.spacePanel.updated,
                            container: `#componet_${this._uid}`,
                            type: 'is-success',
                        });
                    },
                    (error) => this.showError(error, `#componet_${this._uid}`),
                    () => this.$emit('update:loading', this.loading - 1)
                );
            },

            deleteSpace(space) {
                this.$emit('update:loading', this.loading + 1);
                this.resetErrors();

                this.$api.deleteSpace(
                    space.id,
                    () => {
                        this.init();
                        this.$emit('updateSpace');
                        this.$toast({
                            message: this.$dicc.spacePanel.deleted,
                            container: `#componet_${this._uid}`,
                            type: 'is-success',
                        });
                    },
                    (error) => this.showError(error, `#componet_${this._uid}`),
                    () => this.$emit('update:loading', this.loading - 1)
                );
            },
        },
    };
</script>
